import { render, staticRenderFns } from "./add-nutrition.vue?vue&type=template&id=64df6ebb&scoped=true&"
import script from "./add-nutrition.vue?vue&type=script&lang=js&"
export * from "./add-nutrition.vue?vue&type=script&lang=js&"
import style0 from "./add-nutrition.vue?vue&type=style&index=0&id=64df6ebb&lang=less&scoped=true&"
import style1 from "./add-nutrition.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df6ebb",
  null
  
)

export default component.exports